import { render, staticRenderFns } from "./BindsMenuItem.vue?vue&type=template&id=1b3316e1&"
import script from "./BindsMenuItem.vue?vue&type=script&lang=js&"
export * from "./BindsMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports